import colors from './baseColors'

export default {
  buttonHighlightPrimaryBgDefault: colors.primarySolid500,
  buttonHighlightQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonHighlightPrimaryBgPressed: colors.primarySolid400,
  buttonHighlightPrimaryBgHover: colors.primarySolid400,
  buttonHighlightPrimaryBgDisabled: colors.primarySolid800,
  buttonHighlightQuaternaryLabelDefault: colors.primarySolid300,
  buttonHighlightQuaternaryIconDefault: colors.primarySolid300,
  buttonHighlightQuaternaryIconPressed: colors.primarySolid400,
  buttonHighlightQuaternaryIconHover: colors.primarySolid400,
  buttonHighlightQuaternaryIconDisabled: colors.primarySolid900,
  buttonHighlightSecondaryBgDefault: colors.primarySolid900,
  buttonHighlightSecondaryBgPressed: colors.primarySolid800,
  buttonHighlightSecondaryBgHover: colors.primarySolid800,
  buttonHighlightSecondaryBgDisabled: colors.primarySolid900,
  buttonHighlightSecondaryLabelDefault: colors.primarySolid100,
  buttonHighlightSecondaryLabelHover: colors.primarySolid100,
  buttonHighlightSecondaryLabelPressed: colors.primarySolid100,
  buttonHighlightSecondaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonHighlightSecondaryIconDefault: colors.neutralSolid0,
  buttonHighlightSecondaryIconPressed: colors.neutralSolid0,
  buttonHighlightSecondaryIconHover: colors.neutralSolid0,
  buttonHighlightSecondaryIconDisabled: colors.neutralWhiteTransparent200,
  buttonHighlightPrimaryLabelDefault: colors.neutralSolid0,
  buttonHighlightPrimaryLabelHover: colors.neutralSolid0,
  buttonHighlightPrimaryLabelPressed: colors.neutralSolid0,
  buttonHighlightPrimaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonHighlightPrimaryIconDefault: colors.neutralSolid0,
  buttonHighlightPrimaryIconPressed: colors.neutralSolid0,
  buttonHighlightPrimaryIconHover: colors.neutralSolid0,
  buttonHighlightPrimaryIconDisabled: colors.neutralWhiteTransparent200,
  buttonHighlightPrimaryStrokePressed: colors.primarySolid400,
  buttonHighlightSecondaryStrokePressed: colors.primarySolid400,
  buttonHighlightTerciaryLabelDefault: colors.neutralSolid0,
  buttonHighlightTerciaryLabelHover: colors.neutralSolid0,
  buttonHighlightTerciaryLabelPressed: colors.neutralSolid0,
  buttonHighlightTerciaryLabelDisabled: colors.primarySolid900,
  buttonHighlightTerciaryStrokePressed: colors.primarySolid400,
  buttonHighlightTerciaryBgHover: colors.primarySolid900,
  buttonHighlightTerciaryBgPressed: colors.primarySolid900,
  buttonHighlightTerciaryIconDefault: colors.primarySolid100,
  buttonHighlightTerciaryIconPressed: colors.primarySolid100,
  buttonHighlightTerciaryIconHover: colors.primarySolid100,
  buttonHighlightTerciaryIconDisabled: colors.primarySolid900,
  buttonHighlightTerciaryStrokeDefault: colors.primarySolid400,
  buttonHighlightTerciaryStrokeHover: colors.primarySolid400,
  buttonHighlightTerciaryStrokeDisabled: colors.primarySolid800,
  tagBgDefault: colors.neutralSolid700,
  tagBgHover: colors.neutralSolid700,
  tagBgPressed: colors.neutralSolid700,
  tagBgDisabled: colors.neutralSolid700,
  tagStrokeFocus: colors.secondarySolid400,
  tagLabelDefault: colors.neutralSolid0,
  tagLabelHover: colors.neutralSolid0,
  tagLabelPressed: colors.neutralSolid0,
  tagLabelDisabled: colors.neutralWhiteTransparent200,
  tagIconDefault: colors.neutralSolid0,
  tagIconHover: colors.neutralSolid0,
  tagIconPressed: colors.neutralSolid0,
  tagIconDisabled: colors.neutralWhiteTransparent200,
  tagBgFocus: colors.neutralSolid700,
  tagLabelFocus: colors.neutralSolid0,
  tagIconFocus: colors.neutralSolid0,
  buttonHighlightQuaternaryLabelHover: colors.primarySolid400,
  buttonHighlightQuaternaryLabelPressed: colors.primarySolid400,
  buttonHighlightQuaternaryLabelDisabled: colors.primarySolid900,
  buttonHighlightQuaternaryStrokePressed: colors.primarySolid400,
  buttonSubtlePrimaryBgDefault: colors.secondarySolid500,
  buttonSubtlePrimaryIconDefault: colors.secondarySolid50,
  buttonSubtlePrimaryIconPressed: colors.secondarySolid50,
  buttonSubtlePrimaryIconHover: colors.secondarySolid50,
  buttonSubtlePrimaryIconDisabled: colors.neutralWhiteTransparent150,
  buttonSubtlePrimaryLabelDefault: colors.secondarySolid50,
  buttonSubtlePrimaryLabelHover: colors.secondarySolid50,
  buttonSubtlePrimaryLabelPressed: colors.secondarySolid50,
  buttonSubtlePrimaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonSubtlePrimaryBgHover: colors.secondarySolid400,
  buttonSubtlePrimaryBgPressed: colors.secondarySolid400,
  buttonSubtlePrimaryBgDisabled: colors.secondarySolid900,
  buttonSubtleSecondaryBgDefault: colors.secondarySolid900,
  buttonSubtleTerciaryBgHover: colors.secondarySolid900,
  buttonSubtleTerciaryBgPressed: colors.secondarySolid900,
  buttonSubtleTerciaryIconDefault: colors.neutralSolid0,
  buttonSubtleTerciaryIconPressed: colors.neutralSolid0,
  buttonSubtleTerciaryIconHover: colors.neutralSolid0,
  buttonSubtleTerciaryIconDisabled: colors.neutralSolid600,
  buttonSubtleTerciaryLabelDefault: colors.neutralSolid0,
  buttonSubtleTerciaryLabelHover: colors.neutralSolid0,
  buttonSubtleTerciaryLabelPressed: colors.neutralSolid0,
  buttonSubtleTerciaryLabelDisabled: colors.neutralSolid600,
  buttonSubtleTerciaryStrokeDefault: colors.secondarySolid300,
  buttonSubtleTerciaryStrokeHover: colors.secondarySolid300,
  buttonSubtleTerciaryStrokePressed: colors.secondarySolid300,
  buttonSubtleTerciaryStrokeDisabled: colors.secondarySolid600,
  buttonSubtleQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonSubtleQuaternaryLabelDefault: colors.secondarySolid200,
  buttonSubtleQuaternaryLabelHover: colors.secondarySolid300,
  buttonSubtleQuaternaryLabelPressed: colors.secondarySolid300,
  buttonSubtleQuaternaryLabelDisabled: colors.secondarySolid600,
  buttonSubtleQuaternaryIconDefault: colors.secondarySolid200,
  buttonSubtleQuaternaryStrokePressed: colors.secondarySolid300,
  buttonSubtleQuaternaryIconHover: colors.secondarySolid300,
  buttonSubtleQuaternaryIconPressed: colors.secondarySolid300,
  buttonSubtleQuaternaryIconDisabled: colors.secondarySolid600,
  buttonSubtleSecondaryIconDefault: colors.secondarySolid50,
  buttonSubtleSecondaryIconPressed: colors.secondarySolid50,
  buttonSubtleSecondaryIconHover: colors.secondarySolid50,
  buttonSubtleSecondaryIconDisabled: colors.neutralWhiteTransparent200,
  buttonSubtleSecondaryLabelDefault: colors.secondarySolid50,
  buttonSubtleSecondaryBgHover: colors.secondarySolid700,
  buttonSubtleSecondaryStrokePressed: colors.secondarySolid300,
  buttonSubtleSecondaryLabelHover: colors.secondarySolid50,
  buttonSubtleSecondaryLabelPressed: colors.secondarySolid50,
  buttonSubtleSecondaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonSubtleSecondaryBgPressed: colors.secondarySolid700,
  buttonSubtleSecondaryBgDisabled: colors.secondarySolid900,
  buttonSubtlePrimaryStrokePressed: colors.secondarySolid300,
  buttonNegativePrimaryBgDefault: colors.redSolid600,
  buttonNegativePrimaryIconDefault: colors.redSolid50,
  buttonNegativePrimaryIconPressed: colors.redSolid50,
  buttonNegativePrimaryIconHover: colors.redSolid50,
  buttonNegativePrimaryIconDisabled: colors.neutralWhiteTransparent200,
  buttonNegativePrimaryLabelDefault: colors.redSolid50,
  buttonNegativePrimaryLabelHover: colors.redSolid50,
  buttonNegativePrimaryLabelPressed: colors.redSolid50,
  buttonNegativePrimaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonNegativePrimaryBgHover: colors.redSolid400,
  buttonNegativePrimaryBgPressed: colors.redSolid400,
  buttonNegativePrimaryBgDisabled: colors.redSolid900,
  buttonNegativeSecondaryBgDefault: colors.redSolid900,
  buttonNegativeTerciaryBgHover: colors.redSolid900,
  buttonNegativeTerciaryBgPressed: colors.redSolid900,
  buttonNegativeTerciaryIconDefault: colors.redSolid50,
  buttonNegativeTerciaryIconPressed: colors.redSolid50,
  buttonNegativeTerciaryIconHover: colors.redSolid50,
  buttonNegativeTerciaryIconDisabled: colors.neutralWhiteTransparent200,
  buttonNegativeTerciaryLabelDefault: colors.redSolid50,
  buttonNegativeTerciaryLabelHover: colors.redSolid50,
  buttonNegativeTerciaryLabelPressed: colors.redSolid50,
  buttonNegativeTerciaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonNegativeTerciaryStrokeDefault: colors.redSolid500,
  buttonNegativeTerciaryStrokeHover: colors.redSolid500,
  buttonNegativeTerciaryStrokePressed: colors.redSolid500,
  buttonNegativeTerciaryStrokeDisabled: colors.redSolid900,
  buttonNegativeQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNegativeQuaternaryLabelDefault: colors.redSolid400,
  buttonNegativeQuaternaryLabelHover: colors.redSolid500,
  buttonNegativeQuaternaryLabelPressed: colors.redSolid500,
  buttonNegativeQuaternaryLabelDisabled: colors.redSolid900,
  buttonNegativeQuaternaryIconDefault: colors.redSolid400,
  buttonNegativeQuaternaryStrokePressed: colors.redSolid500,
  buttonNegativeQuaternaryIconHover: colors.redSolid500,
  buttonNegativeQuaternaryIconPressed: colors.redSolid500,
  buttonNegativeQuaternaryIconDisabled: colors.redSolid900,
  buttonNegativeSecondaryIconDefault: colors.redSolid50,
  buttonNegativeSecondaryIconPressed: colors.redSolid50,
  buttonNegativeSecondaryIconHover: colors.redSolid50,
  buttonNegativeSecondaryIconDisabled: colors.neutralWhiteTransparent200,
  buttonNegativeSecondaryLabelDefault: colors.neutralSolid0,
  buttonNegativeSecondaryBgHover: colors.redSolid800,
  buttonNegativeSecondaryStrokePressed: colors.redSolid500,
  buttonNegativeSecondaryLabelHover: colors.neutralSolid0,
  buttonNegativeSecondaryLabelPressed: colors.neutralSolid0,
  buttonNegativeSecondaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonNegativeSecondaryBgPressed: colors.redSolid800,
  buttonNegativeSecondaryBgDisabled: colors.redSolid900,
  buttonNegativePrimaryStrokePressed: colors.redSolid200,
  fieldRegularBgDefault: colors.neutralSolid900,
  fieldRegularBgHover: colors.neutralSolid900,
  fieldRegularBgPressed: colors.neutralSolid900,
  fieldRegularBgDisabled: colors.neutralSolid900,
  fieldRegularLabelDefault: colors.neutralSolid600,
  fieldRegularLabelHover: colors.neutralSolid600,
  fieldRegularLabelPressed: colors.neutralSolid600,
  fieldRegularLabelFocusTyping: colors.neutralSolid0,
  fieldRegularLabelDisabled: colors.neutralWhiteTransparent150,
  fieldRegularIconDefault: colors.neutralSolid600,
  fieldRegularIconHover: colors.neutralSolid600,
  fieldRegularIconPressed: colors.neutralSolid600,
  fieldRegularIconFocusTyping: colors.neutralSolid600,
  fieldRegularIconDisabled: colors.neutralWhiteTransparent150,
  fieldRegularBgFocusTyping: colors.neutralSolid900,
  fieldRegularBgTyped: colors.neutralSolid900,
  fieldRegularStrokeDefault: colors.neutralSolid600,
  fieldRegularStrokeHover: colors.primarySolid200,
  fieldRegularStrokePressed: colors.primarySolid200,
  fieldRegularStrokeFocusTyping: colors.primarySolid200,
  fieldRegularStrokeTyped: colors.neutralSolid600,
  fieldRegularStrokeDisabled: colors.neutralSolid700,
  fieldRegularLabelTyped: colors.neutralSolid0,
  fieldRegularIconTyped: colors.neutralSolid600,
  fieldNegativeStrokeDefault: colors.redSolid500,
  fieldNegativeStrokeHover: colors.redSolid600,
  fieldNegativeStrokePressed: colors.redSolid600,
  fieldNegativeStrokeFocusTyping: colors.redSolid500,
  fieldNegativeStrokeTyped: colors.redSolid500,
  chipRegularBgDefault: colors.neutralSolid700,
  chipRegularBgHover: colors.neutralSolid600,
  chipRegularBgPressed: colors.neutralSolid600,
  chipRegularBgFocus: colors.neutralSolid700,
  chipRegularBgDisabled: colors.neutralSolid700,
  chipRegularStrokeFocus: colors.secondarySolid400,
  chipRegularLabelDefault: colors.neutralSolid0,
  chipRegularLabelHover: colors.neutralSolid0,
  chipRegularLabelPressed: colors.neutralSolid0,
  chipRegularLabelFocus: colors.neutralSolid0,
  chipRegularLabelDisabled: colors.neutralWhiteTransparent200,
  chipRegularIconDefault: colors.neutralSolid0,
  chipRegularIconHover: colors.neutralSolid0,
  chipRegularIconPressed: colors.neutralSolid0,
  chipRegularIconFocus: colors.neutralSolid0,
  chipRegularIconDisabled: colors.neutralWhiteTransparent200,
  textParagraph: colors.neutralSolid400,
  textCaption: colors.neutralSolid500,
  textHeadingRegular: colors.neutralSolid300,
  textHeadingHighlighted: colors.neutralSolid0,
  textLink: colors.primarySolid500,
  textHeadingSubtle: colors.neutralSolid400,
  rowBgDefault: colors.neutralWhiteTransparent0,
  rowBgHover: colors.neutralSolid800,
  rowBgPressed: colors.neutralSolid800,
  rowBgFocus: colors.neutralSolid700,
  rowBgDisabled: colors.neutralWhiteTransparent70,
  rowStrokeFocus: colors.primarySolid500,
  rowLabelDefault: colors.neutralSolid0,
  rowLabelHover: colors.neutralSolid0,
  rowLabelPressed: colors.neutralSolid0,
  rowLabelFocus: colors.neutralSolid0,
  rowLabelDisabled: colors.neutralWhiteTransparent200,
  rowIconDefault: colors.neutralSolid400,
  rowIconHover: colors.neutralSolid400,
  rowIconPressed: colors.neutralSolid400,
  rowIconFocus: colors.neutralSolid400,
  rowIconDisabled: colors.neutralWhiteTransparent200,
  chipSelectedBgDefault: colors.secondarySolid800,
  chipSelectedBgHover: colors.secondarySolid700,
  chipSelectedBgPressed: colors.secondarySolid700,
  chipSelectedBgFocus: colors.secondarySolid800,
  chipSelectedBgDisabled: colors.secondarySolid800,
  chipSelectedStrokeFocus: colors.secondarySolid400,
  chipSelectedLabelDefault: colors.neutralSolid0,
  chipSelectedLabelHover: colors.neutralSolid0,
  chipSelectedLabelPressed: colors.neutralSolid0,
  chipSelectedLabelFocus: colors.neutralSolid0,
  chipSelectedLabelDisabled: colors.neutralWhiteTransparent200,
  chipSelectedIconDefault: colors.neutralSolid0,
  chipSelectedIconHover: colors.neutralSolid0,
  chipSelectedIconPressed: colors.neutralSolid0,
  chipSelectedIconFocus: colors.neutralSolid0,
  chipSelectedIconDisabled: colors.neutralWhiteTransparent200,
  bgDefault: colors.neutralSolid1000,
  progressElipseDefault: colors.neutralSolid700,
  progressLineDefault: colors.primarySolid500,
  progressLabelDefault: colors.neutralSolid0,
  progressLabelDisabled: colors.neutralSolid600,
  progressLineDisabled: colors.primarySolid800,
  progressElipseDisabled: colors.neutralSolid800,
  buttonHighlightTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonHighlightTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonHighlightQuaternaryBgHover: colors.neutralWhiteTransparent0,
  buttonHighlightQuaternaryBgPressed: colors.primarySolid900,
  buttonHighlightQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonSubtleTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonSubtleTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonSubtleQuaternaryBgHover: colors.neutralWhiteTransparent0,
  buttonSubtleQuaternaryBgPressed: colors.secondarySolid900,
  buttonSubtleQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNegativeTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNegativeTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNegativeQuaternaryBgHover: colors.neutralWhiteTransparent0,
  buttonNegativeQuaternaryBgPressed: colors.redSolid900,
  buttonNegativeQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  chipSelectedStrokeDefault: colors.secondarySolid400,
  chipSelectedStrokeHover: colors.secondarySolid400,
  chipSelectedStrokePressed: colors.secondarySolid400,
  chipSelectedNegativeBgDefault: colors.redTransparent200,
  chipSelectedNegativeBgHover: colors.redTransparent100,
  chipSelectedNegativeBgPressed: colors.redTransparent100,
  chipSelectedNegativeBgFocus: colors.redTransparent200,
  chipSelectedNegativeStrokeDefault: colors.redSolid500,
  chipSelectedNegativeStrokeHover: colors.redSolid500,
  chipSelectedNegativeStrokePressed: colors.redSolid500,
  chipSelectedNegativeStrokeFocus: colors.redSolid500,
  chipSelectedNegativeLabelDefault: colors.neutralSolid0,
  chipSelectedNegativeLabelHover: colors.neutralSolid0,
  chipSelectedNegativeLabelPressed: colors.neutralSolid0,
  chipSelectedNegativeLabelFocus: colors.neutralSolid0,
  chipSelectedNegativeIconDefault: colors.neutralSolid400,
  chipSelectedNegativeIconHover: colors.neutralSolid400,
  chipSelectedNegativeIconPressed: colors.neutralSolid400,
  chipSelectedNegativeIconFocus: colors.neutralSolid400,
  buttonNeutralPrimaryBgDefault: colors.neutralSolid0,
  buttonNeutralPrimaryBgHover: colors.neutralSolid400,
  buttonNeutralPrimaryBgPressed: colors.neutralSolid400,
  buttonNeutralPrimaryBgDisabled: colors.neutralSolid900,
  buttonNeutralPrimaryIconDefault: colors.neutralSolid1000,
  buttonNeutralPrimaryIconPressed: colors.neutralSolid1000,
  buttonNeutralPrimaryIconHover: colors.neutralSolid1000,
  buttonNeutralPrimaryIconDisabled: colors.neutralSolid700,
  buttonNeutralPrimaryLabelDefault: colors.neutralSolid1000,
  buttonNeutralPrimaryLabelHover: colors.neutralSolid1000,
  buttonNeutralPrimaryLabelPressed: colors.neutralSolid1000,
  buttonNeutralPrimaryLabelDisabled: colors.neutralSolid700,
  buttonNeutralPrimaryStrokePressed: colors.neutralSolid0,
  buttonNeutralSecondaryBgDefault: colors.neutralSolid900,
  buttonNeutralSecondaryBgHover: colors.neutralSolid800,
  buttonNeutralSecondaryBgPressed: colors.neutralSolid800,
  buttonNeutralSecondaryBgDisabled: colors.neutralSolid900,
  buttonNeutralSecondaryIconDefault: colors.neutralSolid0,
  buttonNeutralSecondaryIconPressed: colors.neutralSolid0,
  buttonNeutralSecondaryIconHover: colors.neutralSolid0,
  buttonNeutralSecondaryIconDisabled: colors.neutralSolid700,
  buttonNeutralSecondaryLabelDefault: colors.neutralSolid0,
  buttonNeutralSecondaryLabelHover: colors.neutralSolid0,
  buttonNeutralSecondaryLabelPressed: colors.neutralSolid0,
  buttonNeutralSecondaryLabelDisabled: colors.neutralSolid700,
  buttonNeutralSecondaryStrokePressed: colors.neutralSolid0,
  buttonNeutralTerciaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNeutralTerciaryBgHover: colors.neutralSolid900,
  buttonNeutralTerciaryBgPressed: colors.neutralSolid900,
  buttonNeutralTerciaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNeutralTerciaryIconDefault: colors.neutralSolid0,
  buttonNeutralTerciaryIconPressed: colors.neutralSolid0,
  buttonNeutralTerciaryIconHover: colors.neutralSolid0,
  buttonNeutralTerciaryIconDisabled: colors.neutralSolid700,
  buttonNeutralTerciaryLabelDefault: colors.neutralSolid0,
  buttonNeutralTerciaryLabelHover: colors.neutralSolid0,
  buttonNeutralTerciaryLabelPressed: colors.neutralSolid0,
  buttonNeutralTerciaryLabelDisabled: colors.neutralSolid700,
  buttonNeutralTerciaryStrokeDefault: colors.neutralSolid0,
  buttonNeutralTerciaryStrokeHover: colors.neutralSolid0,
  buttonNeutralTerciaryStrokePressed: colors.neutralSolid0,
  buttonNeutralTerciaryStrokeDisabled: colors.neutralWhiteTransparent200,
  buttonNeutralQuaternaryBgDefault: colors.neutralWhiteTransparent0,
  buttonNeutralQuaternaryBgHover: colors.neutralWhiteTransparent0,
  buttonNeutralQuaternaryBgPressed: colors.neutralSolid900,
  buttonNeutralQuaternaryBgDisabled: colors.neutralWhiteTransparent0,
  buttonNeutralQuaternaryLabelDefault: colors.neutralSolid0,
  buttonNeutralQuaternaryLabelHover: colors.neutralSolid400,
  buttonNeutralQuaternaryLabelPressed: colors.neutralSolid400,
  buttonNeutralQuaternaryLabelDisabled: colors.neutralWhiteTransparent200,
  buttonNeutralQuaternaryIconDefault: colors.neutralSolid0,
  buttonNeutralQuaternaryIconHover: colors.neutralSolid400,
  buttonNeutralQuaternaryIconPressed: colors.neutralSolid400,
  buttonNeutralQuaternaryIconDisabled: colors.neutralWhiteTransparent200,
  buttonNeutralQuaternaryStrokePressed: colors.neutralSolid0,
  shadowPressed: colors.neutralWhiteTransparent250,
  blackonwhite: colors.neutralSolid0,
  whiteonwhite: colors.neutralSolid1000,
  tabbaritemUnselected: colors.neutralWhiteTransparent500,
  tabbaritemSelected: colors.neutralSolid0,
  stroke: colors.neutralWhiteTransparent200,
  cardBg: colors.neutralSolid900,
  modalShadow: colors.neutralSolid900,
  modalStroke: colors.neutralSolid800,
  toggleUnselectedBgActive: colors.neutralSolid700,
  toggleSelectedBgActive: colors.secondarySolid400,
  toggleUnselectedBgDisabled: colors.neutralSolid700,
  toggleSelectedBgDisabled: colors.secondarySolid800,
  toggleUnselectedControlActive: colors.neutralSolid0,
  toggleUnselectedControlDisabled: colors.neutralSolid600,
  toggleSelectedControlActive: colors.neutralSolid0,
  toggleSelectedControlDisabled: colors.neutralSolid600,
  chipSelectedStrokeDisabled: colors.secondarySolid600,
  bgDarker: colors.neutralSolid900,
  headerShadow: colors.neutralBlackTransparent300,
  chatbubbleShadow: colors.neutralBlackTransparent400,
  sliderBgActive: colors.neutralSolid700,
  sliderControlActive: colors.secondarySolid400,
  sliderControlStrokeUniversal: colors.bgDefault,
  sliderFgActive: colors.secondarySolid400,
  sliderBgDisabled: colors.neutralSolid800,
  sliderControlDisabled: colors.secondarySolid800,
  sliderFgDisabled: colors.secondarySolid800,
  fieldNegativeBgDefault: colors.redTransparent100,
  fieldNegativeBgHover: colors.redTransparent200,
  fieldNegativeBgPressed: colors.redTransparent200,
  fieldNegativeBgFocusTyping: colors.redTransparent100,
  fieldNegativeBgTyped: colors.redTransparent100,
  fieldNegativeLabelDefault: colors.redSolid400,
  fieldNegativeLabelHover: colors.redSolid400,
  fieldNegativeLabelPressed: colors.redSolid400,
  fieldNegativeLabelFocusTyping: colors.neutralSolid0,
  fieldNegativeLabelTyped: colors.neutralSolid0,
  fieldNegativeIconDefault: colors.neutralSolid600,
  fieldNegativeIconHover: colors.neutralSolid600,
  fieldNegativeIconPressed: colors.neutralSolid600,
  fieldNegativeIconFocusTyping: colors.neutralSolid600,
  fieldNegativeIconTyped: colors.neutralSolid600,
  bgDefaultMedium: colors.neutralSolid900,
  bgChat: colors.neutralSolid700,
  bgDefault2: colors.neutralSolid1000,
}
